module.exports = __webpack_public_path__ + "img/send1_select.b9379eb1.png";